import { render, staticRenderFns } from "./ClientBuild.vue?vue&type=template&id=56439bd4&scoped=true&"
import script from "./ClientBuild.vue?vue&type=script&lang=js&"
export * from "./ClientBuild.vue?vue&type=script&lang=js&"
import style0 from "./ClientBuild.vue?vue&type=style&index=0&id=56439bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56439bd4",
  null
  
)

component.options.__file = "ClientBuild.vue"
export default component.exports